import type { Channel } from '@missionlabs/smartagent-lib-shared/build/form-templates/form-template.schema'
import type { ISettings } from '@missionlabs/smartagent-lib-shared/build/settings'

import { IQueue } from 'store/settings/settings.state'
import RootState from 'store/state'

export const isAnEmail = (email: string) => /[^@]+@[^.]+\..+/.test(email)

export const getSettingsChannelFromPath = (path: string) => {
    switch (path) {
        case '/task':
            return 'TASK'
        case '/chat':
            return 'CHAT'
        default:
            return 'VOICE'
    }
}

export const getSettingsAppConfigForChannel = (
    appConfiguration?: ISettings['appConfigurations'],
    channel?: Channel,
) => {
    switch (channel) {
        case 'TASK':
            return appConfiguration?.task || appConfiguration
        case 'CHAT':
            return appConfiguration?.chat || appConfiguration
        default:
            return appConfiguration
    }
}

export const getRTMQueuesFromState = (state: RootState): [IQueue[] | undefined, boolean] => {
    const { settings, metrics } = state

    const queues = settings?.enabledQueues
    const queuesLoading = metrics?.queuesLoading || !settings?.enabledQueues

    return [queues, queuesLoading]
}
